<template>
  <v-container fluid grid-list-xl>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <v-text-field
              :label="labels.nombre"
              v-model="responsable.nombre"
              @click:append="editarResponsable('nombre')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.primer_apellido"
              v-model="responsable.primer_apellido"
              @click:append="editarResponsable('primer_apellido')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.segundo_apellido"
              v-model="responsable.segundo_apellido"
              @click:append="editarResponsable('segundo_apellido')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.cargo"
              v-model="responsable.cargo.nombre"
              @click:append="editarResponsable('cargo')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.curp"
              v-model="responsable.curp"
              @click:append="editarResponsable('curp')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.rfc"
              v-model="responsable.rfc"
              @click:append="editarResponsable('rfc')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.abreviatura_titulo"
              v-model="responsable.abreviatura_titulo"
              @click:append="editarResponsable('abreviatura_titulo')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.documento_a_firmar"
              v-model="responsable.documento_a_firmar"
              @click:append="editarResponsable('documento_a_firmar')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>

            <v-text-field
              :label="labels.tipo_de_rvoe_a_firmar"
              v-model="responsable.tipo_de_rvoe_a_firmar"
              @click:append="editarResponsable('tipo_de_rvoe_a_firmar')"
              append-icon="edit"
              outline
              readonly
            ></v-text-field>
            
            <v-autocomplete
              @keyup.enter="$event.target.blur()"
              :label="labels.campuses_a_firmar"
              v-model="responsable.campuses"
              :items="responsable.campuses"
              item-text="nombre"
              item-value="id"
              attach
              chips
              multiple
              @click:append="editarResponsable('campuses')"
              append-icon="edit"
              outline
              readonly
            ></v-autocomplete>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({
      loading: false,
      
      responsable: {
        cargo: {}
      },
    }),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'responsables' })
        }
      }
    },

    mounted() {
      this.getResponsable(this.$route.params.id)
    },

    methods: {
      getResponsable(id) {
        axios.get(api.path('responsables.single', { id: id } ))
          .then(res => {
            this.responsable = res.data
          })
          .catch(err => {
            this.handleErrors(err.response.data.errors)
          })
          .then(() => {})
      },

      editarResponsable(campo) {
        this.$router.push({ name: "responsables-editar", params: { 'campo': campo } })
      }
    }
  }
</script>
